import {
    ChangeDetectionStrategy,
    Component,
    computed,
    input,
    Signal,
} from '@angular/core';
import { ContentfulService } from '@core/services/contentful.service';
import { faLongArrowAltRight } from '@fortawesome/free-solid-svg-icons';
import { Itinerary, KnowledgeDestination, Trip } from '@generated/graphql';

import { TripsItineraryCardComponent } from '@features/trips/components/trips-itinerary-card/trips-itinerary-card.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-knowledge-variation-cards',
    templateUrl: './knowledge-variation-cards.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FontAwesomeModule, TripsItineraryCardComponent],
})
export class KnowledgeVariationCardsComponent {
    destination = input<KnowledgeDestination>();
    slim = input<boolean>(false);
    promotedItinerariesItems: Signal<Itinerary[]>;
    faLongArrowAltRight = faLongArrowAltRight;
    constructor(private contentfulService: ContentfulService) {
        this.promotedItinerariesItems = computed(() => {
            const destination = this.destination();
            if (destination?.promotedItinerariesCollection?.items.length > 0) {
                return destination.promotedItinerariesCollection.items.filter(
                    itinerary => !!itinerary?.urlSlug
                );
            } else {
                return (
                    destination?.contentfulTrip?.linkedFrom?.itineraryCollection
                        ?.items || []
                );
            }
        });
    }

    preloadTrip(trip: Trip) {
        this.contentfulService.trip(trip.urlSlug).subscribe();
    }
}
